import { Application } from '@hotwired/stimulus'

import CollectionController from './controllers/collection_controller'
import PromoMessageController from './controllers/promo_message_controller'
import DrawerController from './controllers/drawer_controller'
import MainMenuMobileController from './controllers/main_menu_mobile_controller'
import SearchDrawerController from './controllers/searchspring/search_drawer_controller'
import ProductController from './controllers/product_controller'
import ProductCtaController from './controllers/product_cta_controller'
import ProductGalleryController from './controllers/product_gallery_controller'
import ProductDescriptionController from './controllers/product_description_controller'
import MainMenuController from './controllers/main_menu_controller'
import PdpSearchspringPersonalizationController from './controllers/pdp_searchspring_personalization_controller'
import SelectController from './controllers/select_controller'
import SearchPageController from './controllers/searchspring/search_page_controller'
import RedirectController from './controllers/redirect_controller'
import BackToTopController from './controllers/back_to_top_controller'

const application = Application.start()

// Register controllers manually
application.register('redirect', RedirectController)
application.register('search-drawer', SearchDrawerController)
application.register('search-page', SearchPageController)
application.register('collection', CollectionController)
application.register('promo-message', PromoMessageController)
application.register('drawer', DrawerController)
application.register('mobile-menu', MainMenuMobileController)
application.register('product', ProductController)
application.register('product-cta', ProductCtaController)
application.register('product-description', ProductDescriptionController)
application.register('product-gallery', ProductGalleryController)
application.register('main-menu', MainMenuController)
application.register(
  'pdp-searchspring-personalization',
  PdpSearchspringPersonalizationController,
)
application.register('select', SelectController)
application.register(
  'pdp-searchspring-personalization',
  PdpSearchspringPersonalizationController,
)
application.register('back-to-top', BackToTopController)

// Make Stimulus available globally for debugging
declare global {
  interface Window {
    Stimulus: Application
  }
}
window.Stimulus = application
